// extracted by mini-css-extract-plugin
module.exports = {"modal-footer":"ModalFooter_modal-footer__q0oiP"};